import React, { useEffect, useState, useContext } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig.js";
import { AuthContext } from "../context/AuthContext.js";  // Asegúrate de que el path a tu configuración de Firebase sea correcto
import { useNavigate } from 'react-router-dom';

const ContractedProfessionals = () => {
  const [professionals, setProfessionals] = useState([]);
  const { currentUser } = useContext(AuthContext);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchContractedProfessionals = async () => {
      if (!currentUser) return; // Verifica si el usuario está autenticado

      try {
        // Obtener solicitudes asignadas que coincidan con el usuario autenticado
        const solicitudesSnapshot = await getDocs(collection(db, "solicitudservicios"));
        const solicitudes = solicitudesSnapshot.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter(
            (solicitud) =>
              solicitud.asignado && solicitud.uid === currentUser.uid // Filtrar por cliente autenticado
          );

        // Obtener información de los usuarios asignados
        const userUids = [...new Set(solicitudes.map((solicitud) => solicitud.asignado))];
        const usersSnapshot = await getDocs(collection(db, "users"));
        const users = usersSnapshot.docs.map((doc) => ({ uid: doc.id, ...doc.data() }));

        // Crear un mapa para evitar duplicados
        const uniqueProfessionals = new Map();

        solicitudes.forEach((solicitud) => {
          const profesional = users.find((user) => user.uid === solicitud.asignado);
          if (profesional && !uniqueProfessionals.has(profesional.uid)) {
            uniqueProfessionals.set(profesional.uid, {
              solicitudId: solicitud.id,
              fullName: profesional.fullName || "Desconocido",
              profession: profesional.profession || "Sin categoría",
              promedioPuntuacion: profesional.promedioPuntuacion || null,
              uid: profesional.uid,
            });
          }
        });

        setProfessionals(Array.from(uniqueProfessionals.values()));
      } catch (error) {
        console.error("Error al obtener profesionales contratados:", error);
      }
    };

    fetchContractedProfessionals();
  }, [currentUser]);

  // Manejo de la paginación
  const totalPages = Math.ceil(professionals.length / itemsPerPage);
  const currentProfessionals = professionals.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="contracted-professionals-container">
      <h2>Profesionales Contratados</h2>
      {currentProfessionals.length > 0 ? (
        <table className="requests-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Servicio</th>
              <th>Calificación</th>
            </tr>
          </thead>
          <tbody>
            {currentProfessionals.map((prof) => (
              <tr key={prof.uid}>
                <td onClick={() => navigate(`/personal-card/${prof.uid}`)}>{prof.fullName}</td>
                <td>{prof.profession}</td>
                <td>
                  {prof.promedioPuntuacion !== null 
                    ? (
                        <>
                          {parseFloat(prof.promedioPuntuacion).toFixed(2)}<i className="fas fa-star" style={{ color: 'gold' }}></i>
                        </>
                      ) 
                    : "Sin calif."
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No hay profesionales contratados para mostrar.</p>
      )}

      <div className="pagination">
        {currentPage > 1 && (
          <button onClick={handlePrevPage}>Anterior</button>
        )}
        {currentPage < totalPages && (
          <button onClick={handleNextPage}>Siguiente</button>
        )}
      </div>
    </div>
  );
};

export default ContractedProfessionals;
